import { render, staticRenderFns } from "./Normalizador.vue?vue&type=template&id=11bde446&scoped=true&"
import script from "./Normalizador.vue?vue&type=script&lang=js&"
export * from "./Normalizador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bde446",
  null
  
)

export default component.exports